import { ErrorPage } from "@snapchat/web-frame";
import { grafanaBasePrefix } from "../lib/grafana";
import { POLICY_DIRECTIVES } from "../constants/csp";
export default function Error() {
    return <ErrorPage grafanaBasePrefix={grafanaBasePrefix} policyDirectives={POLICY_DIRECTIVES}/>;
}
